import { CssBaseline } from '@material-ui/core';
import React from 'react';
import Loader from "react-loader-spinner";



function IconSpinner() {
    return (
        <div>
             <Loader type="Oval" color="#4a4a4a" height={25} width={25} />
        </div>
    )
}

export default IconSpinner
